import Component from '@glimmer/component'
import { registerDestructor } from '@ember/destroyable'
import { command } from 'customer-flows/utils/core'

export default class BookingAbandonmentUnloadGuard extends Component {
  @command('booking-abandonment') trackExposure: BookingAbandonmentCommands['trackExposure']
  @command('booking-abandonment') isActive: BookingAbandonmentCommands['isActive']
  @command('booking-abandonment') shouldBlockUnload: BookingAbandonmentCommands['shouldBlockUnload']

  constructor(owner: unknown, args: object) {
    super(owner, args)

    this.trackExposure()

    if (!this.isActive()) return

    window.addEventListener('beforeunload', this.onBeforeUnload)
    registerDestructor(this, () => window.removeEventListener('beforeunload', this.onBeforeUnload))
  }

  onBeforeUnload = (event: BeforeUnloadEvent) => {
    if (!this.shouldBlockUnload()) return

    event.preventDefault()
    event.returnValue = ''
  }

  <template></template>
}
